import { render, staticRenderFns } from "./shopee-order.vue?vue&type=template&id=65a54cf7&"
import script from "./shopee-order.vue?vue&type=script&lang=js&"
export * from "./shopee-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports